import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './testeQualidadeForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUnidade, getListaMotorista, 
	getListaCliente, getListaEndereco, getListaProduto

} from './testeQualidadeActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import consts from '../consts';

class TesteQualidade extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaUnidade();
		this.props.getListaMotorista();
		this.props.getListaCliente();
		this.props.getListaEndereco();
		this.props.getListaProduto();
	}
	
	componentWillUnmount() {
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar Unidade'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ 
										datahora_realizacao: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										local: 'unidade'
									});
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar Cliente'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ 
										datahora_realizacao: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										local: 'cliente'
									});
								}} />
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>
					
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Local</Th>
								<Th alignCenter>Unidade / Cliente</Th>
								<Th alignCenter>Produto</Th>
								<Th alignCenter>Técnico</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`
										${DateFormat.formatarDataHoraSqlParaTela(item.datahora_realizacao)}
										${item.id_unidade ? 'Unidade' : 'Cliente'}
										${item.nome_unidade || (`${item.nome_cliente} - ${item.nome_endereco}`)}
										${item.nome_produto}
										${item.nome_tecnico}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}

								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_realizacao)}</Td>
									<Td alignCenter>{item.id_unidade ? 'Unidade' : 'Cliente'}</Td>
									<Td alignCenter>{item.nome_unidade || (`${item.nome_cliente} - ${item.nome_endereco}`)}</Td>
									<Td alignCenter>{item.nome_produto}</Td>
									<Td alignCenter>{item.nome_tecnico}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													local: item.id_unidade ? 'unidade' : 'cliente',
													datahora_realizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_realizacao),
													temperatura: FormatUtils.formatarValorTela(item.temperatura, 4),
													massa: FormatUtils.formatarValorTela(item.massa, 4),
													densidade: FormatUtils.formatarValorTela(item.densidade, 4)
												});
												this.props.initForm({
													...item,
													local: item.id_unidade ? 'unidade' : 'cliente',
													datahora_realizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_realizacao),
													temperatura: FormatUtils.formatarValorTela(item.temperatura, 4),
													massa: FormatUtils.formatarValorTela(item.massa, 4),
													densidade: FormatUtils.formatarValorTela(item.densidade, 4)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													local: item.id_unidade ? 'unidade' : 'cliente',
													datahora_realizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_realizacao),
													temperatura: FormatUtils.formatarValorTela(item.temperatura, 4),
													massa: FormatUtils.formatarValorTela(item.massa, 4),
													densidade: FormatUtils.formatarValorTela(item.densidade, 4)
												});
												this.props.initForm({
													...item,
													local: item.id_unidade ? 'unidade' : 'cliente',
													datahora_realizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_realizacao),
													temperatura: FormatUtils.formatarValorTela(item.temperatura, 4),
													massa: FormatUtils.formatarValorTela(item.massa, 4),
													densidade: FormatUtils.formatarValorTela(item.densidade, 4)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.testeQualidade,
	modoTela: state.testeQualidade.modoTela,
	lista: state.testeQualidade.lista,
	listaMotorista: state.testeQualidade.listaMotorista,
    listaUnidade: state.testeQualidade.listaUnidade,
    listaCliente: state.testeQualidade.listaCliente,
    listaEndereco: state.testeQualidade.listaEndereco,
    listaProduto: state.testeQualidade.listaProduto
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUnidade, getListaMotorista, 
	getListaCliente, getListaEndereco, getListaProduto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(TesteQualidade);
